import { ChangeEvent, Fragment, useState, useReducer } from 'react';
import {
    Badge,
    Button,
    Col,
    Container,
    DropdownButton,
    Form,
    Row,
} from 'react-bootstrap';
import { ISafTableFilter } from './ISafTableFilter';
import { ISafTableFilterDefinition } from './ISafTableFilterDefinition';
import _ from 'lodash';

export interface ISafTableFilterProps {
    filters: ISafTableFilterDefinition[]
    isOpen: boolean;
    handleOpen: (value: boolean) => void;
    onFilters: (filters: ISafTableFilter[]) => void;
    initialFilterState?: ISafTableFilter[]
}

export const SafTableFilters = ({
    filters,
    isOpen,
    handleOpen,
    onFilters,
    initialFilterState
}: ISafTableFilterProps) => {

    const [isDirty, setIsDirty] = useState<boolean>(false);
    const [cleanCache, setCleanCache] = useState<ISafTableFilter[]>([]);
    const [activeFilters, setActiveFilters] = useState<number>(initialFilterState?.length ?? 0)

    enum ActionType {
        Add,
        Remove,
        Revert
    }

    const initialFilters: ISafTableFilter[] = initialFilterState ?? [];

    const tableFilterReducer = (state: ISafTableFilter[], action: { type: ActionType; value?: ISafTableFilter; }) => {
        switch (action.type) {
            case ActionType.Add:
                if(!action.value){
                    return state;
                }
                if (state.some(x => _.isEqual(x, action.value))) {
                    return state;
                }
                else {
                    return state.concat(action.value);
                }
            case ActionType.Remove:
                if(!action.value){
                    return state;
                }
                return state.filter(x => !_.isEqual(x, action.value))
            case ActionType.Revert:
                return cleanCache;
            default:
                return state;
        }
    };

    
    const [tableFilters, dispatchFilterChange] = useReducer(tableFilterReducer, initialFilters);



    const handleCancel = () => {
        if (isDirty) dispatchFilterChange({type: ActionType.Revert})
        setIsDirty(false);
        handleOpen(false);
    };

    const handleToggle = () => {
        !isOpen ? handleOpen(true) : handleCancel();
    }

    const handleApply = () => {
        setIsDirty(false);
        handleOpen(false);
        setActiveFilters(tableFilters.length);
        onFilters(tableFilters);
    };

    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>, filter: ISafTableFilter) => {
        if (!isDirty){
            setCleanCache(tableFilters);
        }
        setIsDirty(true);

        if (event.target.checked) {
            dispatchFilterChange({ type: ActionType.Add, value: filter })
        } else {
            dispatchFilterChange({ type: ActionType.Remove, value: filter })
        }
    };

    // TODO: This is a bit wonky should be based on what is applied.
    const renderFilterBadge = (): JSX.Element => {
        return <span>Filters {activeFilters > 0 && <Badge bg="danger">{activeFilters}</Badge>}</span>;
    };

    return (
        <Fragment>
            <DropdownButton
                variant="primary"
                title={renderFilterBadge()}
                onToggle={handleToggle}
                show={isOpen}
            >
                <Container className="py-2">
                    {filters.map((filter, index) => {
                        return (
                            <Row key={index}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label><h6>{filter.label}</h6></Form.Label>
                                        {
                                            filter.values.map((value) => {
                                                return (

                                                    <Form.Check
                                                        key={value}
                                                        type="checkbox"
                                                        label={value}
                                                        onChange={(event) => {
                                                            handleFilterChange(event, {
                                                                id: filter.property,
                                                                value
                                                            });
                                                        }}
                                                        checked={tableFilters.some((safTableFilter) =>
                                                            _.isEqual(safTableFilter, {
                                                                id: filter.property,
                                                                value
                                                            })
                                                        )}
                                                    />
                                                )
                                            })
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>
                        )

                    })}

                    <Row className='filter-controls align-items-center flex-nowrap pt-2'>
                        <Col>
                            <Button disabled={!isDirty} onClick={handleApply}>
                                Apply
                            </Button>
                        </Col>
                        <Col>
                            <Button variant="danger" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </DropdownButton>
        </Fragment>

    );
};
